// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageLabel_root__3Emcs","image":"ImageLabel_image__11qci","loaded":"ImageLabel_loaded__1qJB1","error":"ImageLabel_error__2naPW","label":"ImageLabel_label__g3py8"};